// extracted by mini-css-extract-plugin
module.exports = {"input":"Radio_input__2-lSL","radio":"Radio_radio__3K4Ch","label":"Radio_label__3_uJE","disabled":"Radio_disabled__nDNUt","dot":"Radio_dot__1kbuf"};